<template>
	<div class="qyjs_box">
		<div>
			<router-view></router-view>
		</div>
		<div class="box">
			<div class="boxA">
					<div class="box-tit"><span v-for="(item,index) in navData" :class="navDataIndex==index?'onsele':''"
							@click="navClick(index)">{{item}}</span></div>
			
				<div class="jiben" >
					<div class="jibenul">	
						<div class="jibenul-l">
							<el-tree
							  :data="deptOptions"
							  :props="defaultProps"
							  :filter-node-method="filterNode"
							  ref="tree"
							  highlight-current
							  node-key='id'
							  :default-expanded-keys="ssDaArr"
							  @node-click="handleNodeClick"
							/>
						</div>
						<div class="jibenul-r" v-if="rightData&&rightData.length">
							<div class="jibenul-rtit" v-if="rightData[0]">{{rightData[0].level3Name}}</div>
							<div v-for="(item,index) in rightData" class="jibenul-rli" @click="goInfo(item)">
								<div class="jibenul-r-a">
									<div>{{item.majorName}}</div>
									<span>专业代码:{{item.majorCode}}</span>
								</div>
								<div class="jibenul-r-b">
									<div v-if="item.limitYear">修业年限：{{item.limitYear}}</div>
									<div v-if="item.degree">授予学位：{{item.degree}}</div>
									<div v-if="(item.boyRate&&item.boyRate!=0)||(item.girlRate&&item.girlRate!=0)">男女比列：{{item.boyRate}}：{{item.girlRate}}</div>
									<div v-if="item.money&&item.money!=0">平均薪酬：{{item.money}}</div>
								</div>
							</div>
						</div>
						<div class="jibenul-r" v-else>
							<el-empty  :image-size="200"></el-empty>
						</div>
					</div>
					
				</div>

				<!-- <div class="jiben jiben-a" v-if="navDataIndex==1">
					1111111
				</div>

				<div class="jiben jiben-a" v-if="navDataIndex==3">
					2222222
				</div> -->
			</div>
		</div>
		<!-- <div ref="loadMoreTrigger" style="height: 100px;"></div> -->

	</div>
</template>

<script>
	import {
		UPLODE_URL
	} from '@/utils/request'
	import {
		EventBus
	} from '@/utils/event-bus.js';
	import nVip from '@/components/n-vip.vue';
	export default {
		components: {
			nVip
		},
		data() {
			return {
				UPLODE_URL,
				token: localStorage.getItem('token') || '',
				user: JSON.parse(localStorage.getItem('user')) || '',
				navData: ['本科(普通)',  '专科'],
				navDataIndex: 0,
				
				defaultProps: {
				  children: "children",
				  label: "majorName"
				  // label: "label"
				},
				deptOptions: undefined,
				deptOptionsNew: undefined,
				ssDaArr:[],
				rightData:[],
			};
		},

		created() {

		},
		mounted() {
			// this.id = localStorage.getItem('xiaoid')
			this.getList(0);
			window.addEventListener('storage', this.handleStorageEvent);
		},
		beforeDestroy() {
			// 移除 storage 事件监听器
			window.removeEventListener('storage', this.handleStorageEvent);
		},
		methods: {
			handleStorageEvent(event) {
			      if (event.key == 'token') {
			        // 更新登录状态
						this.token=localStorage.getItem('token')||''
						this.user=JSON.parse(localStorage.getItem('user'))||''
						this.$router.push({path:'/'})
						window.location.reload()
			        // this.checkLoginStatus();
			      }
			    },
			
			// 跳转专业详情
			goInfo(item){
				// localStorage.setItem('majorId',item.id)
				// this.$router.push({path:'/Ainformation/majorInfo'})
				// return
				
					const route =this.$router.resolve({name:'majorInfo',})
					localStorage.setItem('majorId',item.id)
					localStorage.setItem('majorIdName',item.majorName)
					localStorage.setItem('record',item.record)
					// 打开新窗口并导航至生成的URL
					window.open(route.href, '_blank');
			},
			
			// 接收子组件参数
			handleChildEvent(i) {
				console.log('i', i)
				// EventBus.$emit('noopsycheOpen');
				// EventBus.$emit('open');
				// EventBus.$emit('vipOpen');
				if (i == 1) {
					EventBus.$emit('noopsycheOpen');
				} else if (i == 2) {
					EventBus.$emit('open');
				} else {
					EventBus.$emit('vipOpen');
				}
			},
			// 筛选节点
			filterNode(value, data) {
			  if (!value) return true;
			  return data.label.indexOf(value) !== -1;
			},
			// 节点单击事件
			handleNodeClick(data) {
				console.log('data',data)
				if(data.children){
					return
				}else{
					this.rightData = this.findChildrenById(this.deptOptionsNew,data.id)
				}
			  // this.queryParams.deptId = data.id;
			  // this.handleQuery();
			},
			// nav切换
			navClick(i) {
				this.navDataIndex = i;
				let type=''
				// if(i==0){
				// 	type=0
				// }else if(i==1){
				// 	type=2
				// }else if(i=2){
				// 	type=1
				// }
				if(i==0){
					type=0
				}else if(i==1){
					type=1
				}
				this.getList(type)
			},

			// 数据列表请求
			getList(type) {
				let qu = {
					record: type
				}
				this.rightData = []
				this.api.homeMajorListApi(qu).then(res => {
					if (res.code == 200) {
						if(res.data){
							this.deptOptionsNew =JSON.parse(JSON.stringify(res.data)) 					// if(res.data[0].id&&!res.data[0].children){
							this.deptOptions = this.getTreeData(res.data)							// if(res.data[0].id&&!res.data[0].children){
							if(res.data[0].id&&res.data[0].children&&!res.data[0].children[0].children){
								this.ssDaArr= [res.data[0].id,res.data[0].children[0].id]
								console.log('22222',this.ssDaArr)
							}
						this.rightData = this.findChildrenById(this.deptOptionsNew,this.ssDaArr[1])
						}else{
							this.deptOptions = []
						}
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			
			findChildrenById(nodes, targetId) {
			    for (const node of nodes) {
			        if (node.id == targetId) {
			            return node.children;
			        }
			        if (node.children && node.children.length > 0) {
			            const result = this.findChildrenById(node.children, targetId);
			            if (result) {
			                return result;
			            }
			        }
			    }
			    return null; // 或者可以返回一个空数组 []，根据具体需求调整
			},
			
			
			// 递归判断列表，把最后的children设为undefined
			getTreeData(datas) {
				
				let result = datas;
				  for (let firstLayer of result) {
					if (firstLayer.children) {
					  for (let secondLayer of firstLayer.children) {
						delete secondLayer.children;
					  }
					}
				  }
				  return result;
			},
			
		}
	};
</script>

<style lang="scss" scoped>
	.img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}


	.box {

		.boxA {
			// background: #fff;
			border-radius: 10px;
			padding: 10px 0px 20px 0px;
			margin-top: 10px;

			.box-tit {
				width: 100%;
				height: 40px;
				line-height: 40px;
				border-bottom: 1px solid #F44F4D;
				margin-bottom: 15px;
				display: flex;

				span {
					width: 140px;
					height: 40px;
					line-height: 40px;
					cursor: pointer;
					display: block;
					text-align: center;
					font-size: 15px;
				}

				span.onsele {
					background-color: #F44F4D;
					color: #fff;
					border-radius: 10px 10px 0 0;
					font-size: 15px;
				}
			}

			.search-t {
				width: 30%;
				margin-bottom: 10px;

				.input-with-select {
					border-radius: 4px;

					/deep/.el-input__inner {
						border-color: #F56C6C !important;
					}

					/deep/.el-button--danger {
						border: none !important;
					}

					/deep/.el-button {
						border: 1px solid #f44f4d !important;
						background: #f44f4d;
						color: #fff;
						border-radius: 0 4px 4px 0px;
					}
				}
			}


			.jiben {
				// .introduction-rank-list {
				// 	display: flex;

				// 	.introduction-rank-list-box {
				// 		font-size: 14px;
				// 		background: linear-gradient(0deg, #f8f8f8, #f8f8f8);
				// 		width: 23%;
				// 		height: 30px;
				// 		text-align: center;
				// 		padding: 15px;
				// 		margin-right: 15px;
				// 		border-radius: 8px;

				// 		.nnna {
				// 			color: #F44F4D;
				// 		}
				// 	}
				// }
				
				// <div class="jiben" v-if="navDataIndex==0">
				// 	<div class="jibenul">	
				// 		<div class="jibenul-l">
				// 			<el-tree
				// 			  :data="deptOptions"
				// 			  :props="defaultProps"
				// 			  :filter-node-method="filterNode"
				// 			  ref="tree"
				// 			  highlight-current
				// 			  node-key='id'
				// 			  :default-expanded-keys="ssDaArr"
				// 			  @node-click="handleNodeClick"
				// 			/>
				// 		</div>
				// 		<div class="jibenul-l">
				// 			{{rightData}}
				// 		</div>
				// 	</div>
					
				// </div>
				.jibenul{
					width: 100%;
					display: flex;
					.jibenul-l{
						width: 200px;
						margin-right: 0px;
						border-right:1px solid #f0f0f0;
						margin-right: 20px;
						background-color: #fff;
						border-radius: 10px;
						overflow-x: hidden;
						padding: 20px;
						min-height: 70vh;
						max-height: 70vh;
						overflow-y: scroll;
					}
					
					
					// <div class="jibenul-r">
					// 	<div class="jibenul-rtit">{{rightData[0].level3Name}}</div>
					// 	<div v-for="(item,index) in rightData" class="jibenul-rli">
					// 		<div class="jibenul-r-a">
					// 			<div>{{item.majorName}}</div>
					// 			<span>专业代码{{item.majorCode}}</span>
					// 		</div>
					// 		<div class="jibenul-r-b">
					// 			<div v-if="item.limitYear">修业年限:{{item.limitYear}}</div>
					// 			<div v-if="item.degree">授予学位:{{item.degree}}</div>
					// 			<div v-if="item.boyRate||item.girlRate">男女比列:{{item.boyRate}}:{{item.girlRate}}</div>
					// 			<div v-if="item.money">平均薪酬:{{item.money}}</div>
					// 		</div>
					// 	</div>
					// </div>
					.jibenul-r{
						flex: 1;
						background-color: #fff;
						border-radius: 10px;
						overflow-x: hidden;
						padding: 20px;
						min-height: 70vh;
						max-height: 70vh;
						overflow-y: scroll;
						.jibenul-rtit{
							text-align: center;
							font-size: 16px;
							    color: #f60;
								
								font-weight: 700;
								    font-size: 16px;
								    color: #f60;
								    display: flex;
								    align-items: center;
								    justify-content: center;
								    position: relative;
								    border-radius: 8px;
								    background: #fff9f2;
								    height: 34px;
									margin-bottom: 20px;
						}
						.jibenul-rli{
							margin-bottom: 40px;
							cursor: pointer;;
						}
						.jibenul-rli:hover .jibenul-r-a div{
							color: #f60;
						}
						.jibenul-r-a{
							font-size: 16px;
							color: #333;
							display: flex;
							align-items: center;
							span{
								font-size: 12px;
								    color: #666;
								    height: 20px;
									line-height: 20px;
								    padding: 0 10px;
								    border-radius: 26px;
								    border: 1px solid #d8d8d8;
									margin-left: 10px;
							}
						}
						.jibenul-r-b{
							display: flex;
							margin-top: 15px;
							div{
								margin-right: 10px;
								font-size: 14px;
								    color: #666;
								    display: inline-block;
								    position: relative;
								    margin-right: 8px;
								    height: 22px;
								    line-height: 22px;
								    padding: 0 8px;
								    border-radius: 4px;
								    background: #f5f6f7;
								    margin-bottom: 5px;
							}
						}
						
					}
				}
				
			}

			.jianjie {
				margin-top: 20px;
				position: relative;

				.jianjie-t {
					font-size: 16px;
					color: #333;
					font-weight: bold;
					margin-bottom: 10px;
					display: -webkit-box;
					display: -webkit-flex;
					display: -ms-flexbox;
					display: flex;
					-webkit-box-pack: justify;
					-webkit-justify-content: space-between;
					-ms-flex-pack: justify;
					margin-top: 10px;
				}

				.jianjie-m {
					font-size: 14px;
				}
			}
		}

	}

	/deep/.el-checkbox-button.is-checked .el-checkbox-button__inner {
		background-color: #F34240 !important;
		border-color: #F34240 !important;
		box-shadow: -1px 0 0 0 #F34240 !important;
	}

	/deep/.el-input.is-active .el-input__inner {
		border-color: #F34240 !important;
	}

	/deep/.el-input__inner:focus {
		border-color: #F34240 !important;
	}

	.el-select-dropdown__item.selected {
		color: #F34240 !important
	}

	/deep/.el-carousel__indicator--horizontal {
		padding: 12px 2px;
	}

	.introduction-major-box-list-item {
		margin-bottom: 6px;
	}

	.admit-scoreLine-box-table-th-div {
		font-size: 14px;
		text-align: center;
	}

	.admit-scoreLine-box-table-list-div {
		font-size: 14px;
	}
	/deep/.el-tree-node__content{
		height: 36px!important;
	}
</style>